import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import type { SeasonResponse } from "~types/season";
import { useApi } from "./useApi";
import { useGetLocationParams } from "~hooks/useGetLocationParams.ts";

type TransformFn<T> = (data: SeasonResponse) => T;

export const useFetchSeason = <TTransformedData = SeasonResponse>(
  seasonId?: string,
  params: Record<string, string> = {},
  transformFn: TransformFn<TTransformedData> = (data) => data as unknown as TTransformedData,
  additionalQueryKeys: string[] = [],
  options: Omit<UseQueryOptions<TTransformedData>, "queryKey" | "queryFn"> = {},
) => {
  const request = useApi();
  const { organizationId, sport } = useGetLocationParams();

  const urlParams = new URLSearchParams(params);

  return useQuery({
    queryKey: ["season", sport, organizationId, seasonId, ...additionalQueryKeys, urlParams.toString()],
    queryFn: () =>
      request<SeasonResponse>(`${sport}/o/${organizationId}/seasons/${seasonId}?${urlParams.toString()}`).then(
        transformFn,
      ),
    enabled: !!seasonId && !!organizationId && !!sport,
    ...options,
  });
};
